import type { ComponentProps, ReactNode } from 'react'

export function ModelDetailSection(
  props: ComponentProps<'section'> & {
    heading?: ReactNode
    slots?: { heading?: ReactNode }
  },
) {
  const { heading, slots, ...domProps } = props

  return (
    <section {...domProps}>
      <div className="mb-2 flex items-center">
        {heading && <h2 className="text-base mmd:text-xl">{heading}</h2>}
        {slots?.heading && <div className="ml-auto">{slots.heading}</div>}
      </div>
      {props.children}
    </section>
  )
}
